<!--
 * @Description: 机构审核详情组件
 * @Author: wanqian sunhuihong
 * @Date: 2022-05-25 16:43:52
-->
<template>
   <div class="body">
     <el-dialog class="dialog-inst" width="1000px" :title="dialogTitle" :visible.sync="visible" 
      :close-on-click-modal="false" @open="initData" :before-close='handleCancel' center>
      <div style="margin: 0px 25px 41px 25px;">
        <inst-review-actions-details v-if="isGlobalAdmin && (!review.status || review.status == 2)" 
          :review="review" @handle-review="handleInstReview" />
         <!-- 审核历史 -->
        <review-history v-else :review="review" ></review-history>
      </div>
      <el-steps :active="active" finish-status="success" align-center >
        <el-step title="基本信息" :status="stepStatus(0)"></el-step>
        <el-step title="服务开通" :status="stepStatus(1)"></el-step>
      </el-steps>
      <div class="dialog-body">
        <baseinfo-panel     v-if="active == 0" @panel-operate="handlePanelOperate"/>
        <openhservice-panel v-if="active == 1" @panel-operate="handlePanelOperate"/>
      </div>
    </el-dialog>
   </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import instReviewStore from './InstReviewDetails/InstReviewStore.js'
import BaseInfoPanel from "./InstReviewDetails/InstReviewBaseInfoPanel.vue";
import OpenHservicePanel from "./InstReviewDetails/InstReviewOpenHservicePanel.vue";
import InstReviewActionsDetails from './InstReviewDetails/InstReviewActionsDetails.vue'
import ReviewHistory from './ReviewHistory.vue'

export default {
  name: 'InstReviewDetails',
  props: ["visible", "mode", "instReviewId","isGlobalAdmin"],
  instReviewStore,

  components: {
	  'review-history': ReviewHistory,
    'baseinfo-panel': BaseInfoPanel,
    'openhservice-panel': OpenHservicePanel,
    'inst-review-actions-details': InstReviewActionsDetails,
  },

  data() {
    return {
      active: 0,
      review: {},
    }
  },

  computed: {
    dialogTitle() {
      return this.mode == 'details' ? '机构详情' : '----';
    },
    
    stepStatus() {
      return function(curActive) {
        return (curActive <= this.active) ? 'finish' : 'wait';
      }
    },
  },
  
  methods:{
    initData() {
      this.clearData();
      instReviewStore.commit("changeMode", this.mode);
      this.active = 0;
      this.queryData();
    },

    queryData() {
      let params = {id: this.instReviewId};
      let header = this.encryptionUtil.signatureParams(params, 
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET', 
        url: Constant.URL_GET_INSTITUTION_REVIEW_DO,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
      this.vueRequest(requestData).then(result => {
        if (result != null) {
          this.review = result.data.reviewInstitutionDTO;
          let instDO = result.data.institutionDO;
          instReviewStore.commit('changeBaseInfoDO', instDO.baseInfoDO);
          instReviewStore.commit('changeOpeningHsvcList', instDO.openingHsvcList);
        }
      })
    },

    //审核通过/驳回
    handleInstReview(reviewStatus, version) {
      this.$emit('handle-review-inst', reviewStatus, version);
    },

    clearData() {
      this.active = 0;
      instReviewStore.commit('changeBaseInfoDO', {institution: {},});
      instReviewStore.commit('changeLogoFile', null);
      instReviewStore.commit('changePicFile', null);
    },

    handlePanelOperate(opr) {
      switch(opr) {
        case 'prev': 
          this.handlePrev();
          break;
        case 'next':
          this.handleNext();
          break;
        case 'ok':
          this.handleCancel();
          break;
        case 'cancel':
          this.handleCancel();
          break;
      }
    },

    handlePrev() {
      if (this.active > 0) this.active--;
    },

    handleNext() {
      if (this.active < 2) this.active++;
    },

    handleCancel() {
      this.clearData();
      this.$emit("close-dialog", false);
    },
  },
}
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.review-history-wrap{
	padding: 0 30px;
}

</style>


// WEBPACK FOOTER //
// src/components/review/components/InstReviewDetails.vue